// extracted by mini-css-extract-plugin
export default {"letter":"CellMark_letter__3S92T","number":"CellMark_number__I2nxG"};